import Chip from './Chip'

export default {
  Chip
}



// WEBPACK FOOTER //
// ./src/components/chips/index.js